import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const RepeatSection = ({ onRepeatChange, initialValues = null }) => {
  const { t } = useTranslation('schedule');

  const [isExpanded, setIsExpanded] = useState(false);
  const [recurrence, setRecurrence] = useState(initialValues?.recurrence || null);
  const [endDate, setEndDate] = useState(initialValues?.endDate || getDefaultEndDate());

  function getDefaultEndDate() {
    const date = new Date();
    date.setMonth(date.getMonth() + 6);
    return date.toISOString().split('T')[0];
  }

  const handleRecurrenceChange = (type) => {
    const newRecurrence = recurrence === type ? null : type;
    setRecurrence(newRecurrence);
    onRepeatChange(newRecurrence ? { recurrence: newRecurrence, endDate } : null);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (recurrence) {
      onRepeatChange({ recurrence, endDate: date });
    }
  };

  return (
    <div style={{
      margin: '20px 0',
      borderTop: '1px solid #e0e0e0',
      paddingTop: '15px',
      backgroundColor: '#f9f9f9',
      padding: '15px',
      borderRadius: '8px'
    }}>
      <button
        type="button"
        style={{
          background: 'none',
          border: 'none',
          padding: '8px 0',
          fontSize: '14px',
          fontWeight: '600',
          color: '#333',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: '100%',
          textAlign: 'left'
        }}
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <span style={{ fontSize: '12px' }}>{isExpanded ? '▼' : '▶'}</span>
        {t('repeat.title')}
      </button>

      {isExpanded && (
        <div style={{ marginTop: '15px', paddingLeft: '20px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '15px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
              <input
                type="checkbox"
                checked={recurrence === 'WEEKLY'}
                onChange={() => handleRecurrenceChange('WEEKLY')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <span>{t('repeat.weekly')}</span>
            </label>

            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
              <input
                type="checkbox"
                checked={recurrence === 'BIWEEKLY'}
                onChange={() => handleRecurrenceChange('BIWEEKLY')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <span>{t('repeat.biweekly')}</span>
            </label>

            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
              <input
                type="checkbox"
                checked={recurrence === 'MONTHLY'}
                onChange={() => handleRecurrenceChange('MONTHLY')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <span>{t('repeat.monthly')}</span>
            </label>
          </div>

          {recurrence && (
            <div style={{ marginTop: '15px' }}>
              <label style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px', fontWeight: '500' }}>
                {t('repeat.endDate')}
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => handleEndDateChange(e.target.value)}
                  min={new Date().toISOString().split('T')[0]}
                  required
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </label>
            </div>
          )}

          <p style={{
            marginTop: '15px',
            padding: '10px',
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#856404'
          }}>
            {t('repeat.infoText')}
          </p>
        </div>
      )}
    </div>
  );
};